import { FieldErrors, Path } from 'react-hook-form';
import { HeaderTextStylingOptions } from 'src/features/components/editComponentPage/forms/modules/headerTextStylingAccordion/HeaderTextStylingAccordion.interface';
import { IGcfComponentConfig, IThemeRes } from 'src/interfaces';

export enum DyHeaderOptions {
  KNOWN = 'knownCustomer',
  UNKNOWN = 'unknownCustomer',
}

export interface HeaderWidgetProps {
  componentConfig: IGcfComponentConfig;
  handleOnChange: (keys: Path<IGcfComponentConfig>, value: unknown) => void;
  errors: FieldErrors<IGcfComponentConfig>;
  theme: IThemeRes | undefined;
  hidden?: HeaderTextStylingOptions[];
}
